module.exports = __webpack_public_path__ + "img/hg.4d9c0e8e.jpg";